import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CAMPAIGN_ROUTES, CONTENT_ROUTES, DRB_ROUTES, INSIGHT_ROUTES, QA_ROUTES, QUICKSTART_ROUTES, RFM_ROUTES, SURVEY_ROUTES } from './shared/constants/route-constants';

const routes: Routes = [
  ...QA_ROUTES,
  ...CAMPAIGN_ROUTES,
  ...INSIGHT_ROUTES,
  ...DRB_ROUTES,
  ...CONTENT_ROUTES,
  ...RFM_ROUTES,
  ...SURVEY_ROUTES,
  ...QUICKSTART_ROUTES
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
